import React, { useState, useContext, useLayoutEffect } from "react";
import Chart from "react-apexcharts";
import { TableDataContext } from "../index";
import _ from 'lodash';
import useConfig from "../../../Hooks/useConfig";

function TicketIssueType(props) {
    const {hover_type} = useConfig();
    const { AllDashBoardData } = useContext(TableDataContext);
    const [data, setData] = useState(AllDashBoardData?.TicketsByIssue?.data || []);
    useLayoutEffect(() => {
        setData(AllDashBoardData?.TicketsByIssue?.data || [])
    }, [AllDashBoardData?.TicketsByIssue?.data, AllDashBoardData?.FilterData])

    const categories = Array.isArray(data) ? data.map((item) => item.issue || "") : [];
    const seriesData = Array.isArray(data) ? data.map((item) => item.count || 0) : [];
    const options = {
        chart: {
            height: 350,
            type: "bar",
        },
        plotOptions: {
            bar: {
                dataLabels: {
                    position: "top",
                },
            },
        },
        xaxis: {
            categories: categories.length ? categories : [""],
            title: {
                text: "Tickets Issues",
            },
        },
        yaxis: {
            title: {
                text: "No. of tickets",
            },
            labels: {
                formatter: function (val) {
                    return val;
                },
            },
        },
        dataLabels: {
            style: {
                colors: ["black"],
            },
        },
        chart: {
            toolbar: {
                show: false,
            },
        },
        colors: ["var(--primary-color)"],
        states: {
            hover: {
                filter: {
                    type: hover_type
                }
            }
        },
        tooltip: {
            y: {
                formatter: function (val) {
                    return "Total Tickets: " + val;
                },
                title: {
                    formatter: function (seriesName, val) {
                        return "";
                    },
                },
            },
        },
    };
    return (
        <>
            <div className="col-12 text-center  greyBoxShadow" style={{ height: "100%" }}>
                <div className="w-100">
                    <div className="row my-2 px-2 time">
                        <div className='Header'>
                            <b className='font-15'>Tickets by Issue Type</b><br />
                        </div>
                    </div>
                    {AllDashBoardData?.TicketsByIssue?.loader ? <div className='row'><div className="col-12 text-center pt-2"><img src="/images/loder.svg" className="" style={{ width: "30px" }} /></div></div> :
                        <div className="">
                            {seriesData.length > 0 ? (
                                <div style={{ overflowX: "auto" }}>
                                    <div style={{ width: seriesData.length > 10 ? "1500px" : "100%" }}>
                                        <Chart
                                            options={options}
                                            series={[{ data: seriesData || [] }]} // always []
                                            type="bar"
                                            height={250}
                                        />
                                    </div>
                                </div>
                            ) : (
                                <div className="text-center py-3">No data available</div>
                            )}
                        </div>
                    }
                </div>
            </div>
        </>
    );
}
export default TicketIssueType
